import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "intro"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "spinnerAll"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_modals_container = _resolveComponent("modals-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]),
      _: 1
    }),
    _createVNode(_component_language_selector),
    (_ctx.$store.state.showSpinner > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_mini_spinner)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modals_container, { tabindex: "-1" })
  ], 64))
}